import React from 'react'
import { localize } from '../../util/Localizer'
import { Row, Col } from 'react-flexbox-grid'

const StepOne = () => {
  return (
    <section className='activate activateStep1'>

      <Row>
        <Col xs={12}>
          <h3>{localize('pages.activate.stepOne.title')}...</h3>
          <p>{localize('pages.activate.stepOne.prompt1')}</p>
          <p>{localize('pages.activate.stepOne.prompt2')}:</p>
          <ul>
            <li>{localize('pages.activate.stepOne.listItemOne')}</li>
            <li>{localize('pages.activate.stepOne.listItemTwo')}</li>
            <li>{localize('pages.activate.stepOne.listItemThree')}</li>
            <li>{localize('pages.activate.stepOne.listItemFour')}</li>
            <li>{localize('pages.activate.stepOne.listItemFive')}</li>
            <li>{localize('pages.activate.stepOne.listItemSix')}</li>
            <li>{localize('pages.activate.stepOne.listItemSeven')}</li>
          </ul>
          <p>{localize('pages.activate.stepOne.prompt3Header')}</p>
          <p>{localize('pages.activate.stepOne.prompt3')}</p>
        </Col>
      </Row>

    </section>
  )
}

export default StepOne



// WEBPACK FOOTER //
// ./src/widgets/activate/StepOne.js